import { Fragment } from 'react';

import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';
import { Checkbox } from 'UIPackage/MainModule/components/Checkbox';

import styles from './styles.module.scss';
import { KnmErpObjectChecklist } from './KnmErpObjectChecklist';
import { KnmErpObjectResult } from './KnmErpObjectResult';

interface IKnmErpObjectProps {
  passportData?: IKnmPreview;
}

export const KnmErpObject = ({ passportData }: IKnmErpObjectProps) => (
  <div className={styles.ColumnContent}>
    {passportData?.objects &&
      passportData?.objects.length > 0 &&
      passportData?.objects.map((obj, index) => (
        <Fragment key={index}>
          <span className={styles.SectionTitle}>{`Объект проведения КНМ №${index + 1}`}</span>
          <div className={styles.SectionTitle}>Место #{index + 1}</div>
          {obj.notInFIAS !== undefined && (
            <div className={styles.Row}>
              <div className={styles.ColText}>Иное указание места (нет в ФИАС)</div>
              <div className={styles.ColValue}>
                <Checkbox checked={obj.notInFIAS} size="medium" type="checkbox" theme="system" disabled={true} />
              </div>
            </div>
          )}
          <div className={styles.Row}>
            <div className={styles.ColText}>Адрес объекта проведения КНМ</div>
            <div className={styles.ColValue}>{obj.address ?? obj.manualAddress}</div>
          </div>
          {obj.fiasRegion && (
            <div className={styles.Row}>
              <div className={styles.ColText}>Субъект РФ</div>
              <div className={styles.ColValue}>
                {typeof obj.fiasRegion === 'object' ? obj.fiasRegion.name : obj.fiasRegion}
              </div>
            </div>
          )}
          <div className={styles.Row}>
            <div className={styles.ColText}>Тип адреса места составления акта о проведении КНМ</div>
            <div className={styles.ColValue}>{obj.addressTypeName}</div>
          </div>
          <div className={styles.Row}>
            <div className={styles.ColText}>Тип объекта проведения КНМ</div>
            <div className={styles.ColValue}>{obj.typeName}</div>
          </div>
          {obj.riskName && (
            <div className={styles.Row}>
              <div className={styles.ColText}>Категория риска</div>
              <div className={styles.ColValue}>{obj.riskName}</div>
            </div>
          )}

          <KnmErpObjectChecklist chlistHeaders={obj.chlistHeaders} />
          {passportData?.objects?.[0].supervisions && passportData?.objects[0].supervisions[index] && (
            <>
              <span className={styles.SectionTitle}>Вид государственного контроля (надзора)</span>
              <div className={styles.Row}>
                <div className={styles.ColText}>Вид государственного контроля (надзора)</div>
                <div className={styles.ColValue}>{passportData?.objects[0].supervisions[index].name}</div>
              </div>
            </>
          )}
          <KnmErpObjectResult objectResult={obj.result} />
        </Fragment>
      ))}
  </div>
);
